import React from "react";
import { BadgeIcon } from "icons";
import clsx from "clsx";
import { Program } from "generated/graphql";
import bronze from "assets/images/fidelity/BRONZE.svg";
import platinium from "assets/images/fidelity/Platinum.svg";
import gold from "assets/images/fidelity/Gold1.svg";
import silver from "assets/images/fidelity/Silver.svg";
import { useProgramDetailsStyles } from "../style";

interface ProgramDetailsProps {
  program: Program;
}
function ProgramDetails({ program }: ProgramDetailsProps) {
  const styles = useProgramDetailsStyles();
  const programDetails = {
    Platinium: platinium,
    Gold: gold,
    Silver: silver,
    Bronze: bronze,
  };
  return (
    <div className={clsx(styles.container, "animate-details")}>
      <img src={programDetails[program?.title]} alt="Program Description" className="image" />
      {/* <div className={styles.header}>
        <div className={styles.brandImage}>
          <BadgeIcon width={103} height={102} color="rgba(195, 202, 216, 0.3)" />
        </div>
        <p className={styles.title}>{program?.title}</p>
      </div>
      <p className={styles.description}>{program?.description}</p> */}
    </div>
  );
}

export default ProgramDetails;
